export default __webpack_public_path__ + "static/media/Mern stack developer _4.c3086b1b.pdf";